import React from 'react';
import Helmet from 'react-helmet'
const Showcase = () => {
  return (
    <div className="showcase-container">
      <Helmet>
        <title>Showcase</title>
        <meta name="description" content="Showcase" />
        <meta property="og:title" content="Showcase" />
      </Helmet>
      {/* Use a div to maintain aspect ratio, especially for video content */}
      <div className="video-wrapper">
        <iframe
          className="hero-iframe"
          // Consider adding a `loading="lazy"` attribute for performance if the iframe isn't critical on initial load
          src="https://navarrojalen.netlify.app/videos/public/navarrojalenhomebanner"
          title="Hero Banner"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture" // Add autoplay and picture-in-picture for more control
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Showcase;